import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useCustomer } from "@/context/CustomerAuthContext";
import { LOGO_URL } from "@/lib/brand";

// Handles the fragment "#session_id=..." that Emergent Auth appends on redirect.
// Renders while the exchange is in flight, then navigates to /account.
export default function AuthCallback() {
  const nav = useNavigate();
  const { setCustomer, setReady } = useCustomer();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Idempotent under StrictMode via ref set synchronously.
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      nav("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/customer/session", { session_id: sessionId });
        setCustomer(data);
        setReady(true);
        // Clean the URL and go to account
        window.history.replaceState({}, "", window.location.origin + "/account");
        toast.success(`Welcome, ${data.name.split(" ")[0]}!`);
        nav("/account", { replace: true });
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
        nav("/", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-sj-cream" data-testid="auth-callback">
      <img src={LOGO_URL} alt="" className="h-16 w-16 object-contain shimmer" />
      <div className="mt-6 overline">Signing you in…</div>
      <div className="mt-2 text-sj-inkSoft text-sm">A little starlight on the way ✨</div>
    </div>
  );
}
